import { useLocalSearchParams, router } from "expo-router"
import { ActivityIndicator, Pressable, View } from "react-native"
import Icon from "@react-native-vector-icons/material-design-icons"

import { TransactionForm } from "components/transaction-form/transaction-form"
import { Header } from "components/Header"
import { Text } from "components/core"
import { trpc } from "utils/trpc"
import { ar } from "i18n/ar"

export default function TransactionEdit() {
  const params = useLocalSearchParams<{ id: string }>()
  const id = Number.parseInt(params.id, 10)
  const transaction = trpc.transactions.get.useQuery({ id })

  // Loading state
  if (transaction.isLoading) {
    return (
      <View className="flex-1 bg-gray-50">
        <Header title={ar.editTransaction} />
        <View className="flex-1 items-center justify-center">
          <ActivityIndicator size="large" color="#3B82F6" />
          <Text className="text-gray-500 mt-2">{ar.loading}</Text>
        </View>
      </View>
    )
  }

  // Error state
  if (transaction.error || !transaction.data) {
    return (
      <View className="flex-1 bg-gray-50">
        <Header title={ar.editTransaction} />
        <View className="flex-1 items-center justify-center p-4">
          <Icon name="alert-circle" size={48} color="#EF4444" />
          <Text className="text-red-500 text-center mt-2">{ar.failedToLoadTransactionDetails}</Text>
          <Pressable onPress={() => router.back()} className="mt-4 bg-blue-500 px-6 py-2 rounded active:opacity-70">
            <Text className="text-white font-medium">{ar.goBack}</Text>
          </Pressable>
        </View>
      </View>
    )
  }

  // Cannot edit cancelled transactions
  if (transaction.data.status === "cancelled") {
    return (
      <View className="flex-1 bg-gray-50">
        <Header title={ar.editTransaction} />
        <View className="flex-1 items-center justify-center p-4">
          <Icon name="cancel" size={48} color="#F59E0B" />
          <Text className="text-amber-600 text-center mt-2">{ar.cannotEditTransaction}</Text>
          <Pressable onPress={() => router.back()} className="mt-4 bg-blue-500 px-6 py-2 rounded active:opacity-70">
            <Text className="text-white font-medium">{ar.goBack}</Text>
          </Pressable>
        </View>
      </View>
    )
  }

  return (
    <View className="flex-1">
      <Header
        title={`${ar.editTransaction} #${transaction.data.id}`}
        right={
          <Pressable onPress={router.back} className="h-full px-2 justify-center active:opacity-50">
            <Text className="font-bold text-red-500">{ar.cancel}</Text>
          </Pressable>
        }
      />
      <TransactionForm id={transaction.data.id} />
    </View>
  )
}
